import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import { Link } from "react-router-dom";
import { showHideLoader } from "../utils/helper.js";
import {
  getStatus,
  getTitles,
  getBloodGroups,
  getGenders,
  getQualifications,
  getOccupations,
  getSubscriptions,
  getAreas,
  getTalukas,
  getDistricts,
  getStates,
} from "../../network/lib/masterData.js";
import { memberObject, save, nextRecord } from "../../network/lib/member.js";

function SaveMember({ user }) {
  const [status, setStatus] = useState();
  const [titles, setTitles] = useState();
  const [bloodGroups, setBloodGroups] = useState();
  const [genders, setGenders] = useState();
  const [qualifications, setQualifications] = useState();
  const [occupations, setOccupations] = useState();
  const [subscriptions, setSubscriptions] = useState();
  const [originalAreas, setOriginalAreas] = useState();
  const [originalTalukas, setOriginalTalukas] = useState();
  const [originalDistricts, setOriginalDistricts] = useState();
  const [states, setStates] = useState();
  const [areas, setAreas] = useState();
  const [talukas, setTalukas] = useState();
  const [districts, setDistricts] = useState();
  const [nativeAreas, setNativeAreas] = useState();
  const [nativeTalukas, setNativeTalukas] = useState();
  const [nativeDistricts, setNativeDistricts] = useState();
  const [id, setId] = useState(0);

  const [applicationNumber, setApplicationNumber] = useState("");
  const [dateOfJoining, setDateOfJoining] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [title, setTitle] = useState(0);
  const [nameInMarathi, setNameInMarathi] = useState("");
  const [name, setName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [bloodGroup, setBloodGroup] = useState(0);
  const [gender, setGender] = useState(1);
  const [qualification, setQualification] = useState(0);
  const [occupation, setOccupation] = useState(0);
  const [mobile, setMobile] = useState("");
  const [telephone, setTelephone] = useState("");
  const [mail, setMail] = useState("");
  const [isMailSubscriped, setIsMailSubscriped] = useState(false);
  const [isMessageSubscriped, setIsMessageSubscriped] = useState(false);
  const [addressInMarathi_1, setAddressInMarathi_1] = useState("");
  const [address_1, setAddress_1] = useState("");
  const [addressInMarathi_2, setAddressInMarathi_2] = useState("");
  const [address_2, setAddress_2] = useState("");
  const [addressInMarathi_3, setAddressInMarathi_3] = useState("");
  const [address_3, setAddress_3] = useState("");
  const [customerAreaInMarathi, setCustomAreaInMarathi] = useState("");
  const [customerArea, setCustomArea] = useState("");
  const [state, setState] = useState(0);
  const [district, setDistrict] = useState(0);
  const [taluka, setTaluka] = useState(0);
  const [area, setArea] = useState(0);
  const [pincodeInMarathi, setPincodeInMarathi] = useState("");
  const [pincode, setPincode] = useState("");
  const [nativeAddressInMarathi_1, setNativeAddressInMarathi_1] = useState("");
  const [nativeAddress_1, setNativeAddress_1] = useState("");
  const [nativeAddressInMarathi_2, setNativeAddressInMarathi_2] = useState("");
  const [nativeAddress_2, setNativeAddress_2] = useState("");
  const [nativeAddressInMarathi_3, setNativeAddressInMarathi_3] = useState("");
  const [nativeAddress_3, setNativeAddress_3] = useState("");
  const [nativeCustomerAreaInMarathi, setNativeCustomAreaInMarathi] =
    useState("");
  const [nativeCustomerArea, setNativeCustomArea] = useState("");
  const [nativeState, setNativeState] = useState(0);
  const [nativeDistrict, setNativeDistrict] = useState(0);
  const [nativeTaluka, setNativeTaluka] = useState(0);
  const [nativeArea, setNativeArea] = useState(0);
  const [nativePincodeInMarathi, setNativePincodeInMarathi] = useState("");
  const [nativePincode, setNativePincode] = useState("");
  const [isCreate, setIsCreate] = useState(true);
  const [isRead, setIsRead] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const subscriptionMap = {
    1: [isMailSubscriped, setIsMailSubscriped],
    2: [isMessageSubscriped, setIsMessageSubscriped],
  };

  useEffect(() => {
    !status &&
      getStatus().then((resp) => {
        resp.status == 200 && setStatus(resp.data);
      });
    !titles &&
      getTitles().then((resp) => {
        resp.status == 200 && setTitles(resp.data);
      });
    !bloodGroups &&
      getBloodGroups().then((resp) => {
        resp.status == 200 && setBloodGroups(resp.data);
      });
    !genders &&
      getGenders().then((resp) => {
        resp.status == 200 && setGenders(resp.data);
      });
    !qualifications &&
      getQualifications().then((resp) => {
        resp.status == 200 && setQualifications(resp.data);
      });
    !occupations &&
      getOccupations().then((resp) => {
        resp.status == 200 && setOccupations(resp.data);
      });
    !subscriptions &&
      getSubscriptions().then((resp) => {
        resp.status == 200 && setSubscriptions(resp.data);
      });
    !states &&
      getStates().then((resp) => {
        resp.status == 200 && setStates(resp.data);
      });
    !districts &&
      getDistricts().then((resp) => {
        if (resp.status == 200) {
          setOriginalDistricts(resp.data);
          setDistricts(resp.data);
          setNativeDistricts(resp.data);
        }
      });
    !talukas &&
      getTalukas().then((resp) => {
        if (resp.status == 200) {
          setOriginalTalukas(resp.data);
          setTalukas(resp.data);
          setNativeTalukas(resp.data);
        }
      });
    !areas &&
      getAreas().then((resp) => {
        if (resp.status == 200) {
          setOriginalAreas(resp.data);
          setAreas(resp.data);
          setNativeAreas(resp.data);
        }
      });
    processReadEdit();
  }, []);

  const formatDate = (date) => {
    let dateTime = date.split("T");
    let dateString = dateTime.length > 0 ? dateTime[0] : dateTime;
    const [year, month, day] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const processReadEdit = () => {
    let item = localStorage.getItem("userDetails");
    if (item) {
      localStorage.removeItem("userDetails");
      let data = JSON.parse(item);
      if (data) {
        setIsCreate(false);
        data.isRead && setIsRead(true);
        data.isEdit && setIsEdit(true);
        setId(data.id);
        setApplicationNumber(data.applicationNumber);
        setDateOfJoining(formatDate(data.dateOfJoiningId));
        setSelectedStatus(data.statusId);
        setTitle(data.titleId);
        setNameInMarathi(data.nameInMarathi);
        setName(data.name);
        setDateOfBirth(formatDate(data.dateOfBirthId));
        setBloodGroup(data.bloodGroupId ?? 0);
        setGender(data.genderId);
        setQualification(data.qualificationId ?? 0);
        setOccupation(data.occupationId ?? 0);
        setMobile(data.mobile);
        setTelephone(data.telephone ?? "");
        setMail(data.mail ?? "");
        setIsMailSubscriped(data.isMailSubscriped ?? 0);
        setIsMessageSubscriped(data.isMessageSubscriped ?? 0);
        setAddressInMarathi_1(data.addressInMarathi_1);
        setAddress_1(data.address_1);
        setAddressInMarathi_2(data.addressInMarathi_2 ?? "");
        setAddress_2(data.address_2 ?? "");
        setAddressInMarathi_3(data.addressInMarathi_3 ?? "");
        setAddress_3(data.address_3 ?? "");
        setCustomAreaInMarathi(data.customAreaInMarathi);
        setCustomArea(data.customArea);
        setState(data.stateId);
        setDistrict(data.districtId);
        setTaluka(data.talukaId);
        setArea(data.areaId);
        setPincodeInMarathi(data.pincodeInMarathi);
        setPincode(data.pincode);
        setNativeAddressInMarathi_1(data.nativeAddressInMarathi_1 ?? "");
        setNativeAddress_1(data.nativeAddress_1 ?? "");
        setNativeAddressInMarathi_2(data.nativeAddressInMarathi_2 ?? "");
        setNativeAddress_2(data.nativeAddress_2 ?? "");
        setNativeAddressInMarathi_3(data.nativeAddressInMarathi_3 ?? "");
        setNativeAddress_3(data.nativeAddress_3 ?? "");
        setNativeCustomAreaInMarathi(data.nativeCustomAreaInMarathi ?? "");
        setNativeCustomArea(data.nativeCustomArea ?? "");
        setNativeState(data.nativeStateId ?? 0);
        setNativeDistrict(data.nativeDistrictId ?? 0);
        setNativeTaluka(data.nativeTalukaId ?? 0);
        setNativeArea(data.nativeAreaId ?? 0);
        setNativePincodeInMarathi(data.nativePincodeInMarathi ?? "");
        setNativePincode(data.nativePincode ?? "");
      }
    } else {
      isCreate && nextId();
    }
  };

  const nextId = () => {
    nextRecord().then((resp) => {
      resp.status == 200 && setId(resp.data);
    });
  };

  const setToDefault = () => {
    nextId();
    setIsCreate(true);
    setIsEdit(false);
    setIsRead(false);
    setApplicationNumber("");
    setSelectedStatus(1);
    setDateOfJoining("");
    setTitle(0);
    setNameInMarathi("");
    setName("");
    setDateOfBirth("");
    setBloodGroup(0);
    setGender(1);
    setQualification(0);
    setOccupation(0);
    setMobile("");
    setTelephone("");
    setMail("");
    setIsMailSubscriped(false);
    setIsMessageSubscriped(false);
    setAddressInMarathi_1("");
    setAddress_1("");
    setAddressInMarathi_2("");
    setAddress_2("");
    setAddressInMarathi_3("");
    setAddress_3("");
    setCustomAreaInMarathi("");
    setCustomArea("");
    setState(0);
    setDistrict(0);
    setTaluka(0);
    setArea(0);
    setPincodeInMarathi("");
    setPincode("");
    setNativeAddressInMarathi_1("");
    setNativeAddress_1("");
    setNativeAddressInMarathi_2("");
    setNativeAddress_2("");
    setNativeAddressInMarathi_3("");
    setNativeAddress_3("");
    setNativeCustomAreaInMarathi("");
    setNativeCustomArea("");
    setNativeState(0);
    setNativeDistrict(0);
    setNativeTaluka(0);
    setNativeArea(0);
    setNativePincodeInMarathi("");
    setNativePincode("");
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    if (applicationNumber == "") {
      message.innerHTML = "Please provide Application Number";
    } else if (dateOfJoining == "") {
      message.innerHTML = "Please provide Date of Joining";
    } else if (title == 0 || title == "0") {
      message.innerHTML = "Please select valid Title";
    } else if (nameInMarathi == "" || name == "") {
      message.innerHTML = "Please provide Name";
    } else if (dateOfBirth == "") {
      message.innerHTML = "Please provide Date of Birth";
    } else if (mobile == "") {
      message.innerHTML = "Please provide Mobile Number";
    } else if (addressInMarathi_1 == "" || address_1 == "") {
      message.innerHTML = "Please provide Address 1";
    } else if (customerAreaInMarathi == "" || customerArea == "") {
      message.innerHTML = "Please provide Area";
    } else if (state == 0 || state == "0") {
      message.innerHTML = "Please select valid State";
    } else if (district == "0" || district == 0) {
      message.innerHTML = "Please select valid District";
    } else if (taluka == "0" || taluka == 0) {
      message.innerHTML = "Please select valid Taluka";
    } else if (area == "0" || area == 0) {
      message.innerHTML = "Please select valid Area";
    } else if (pincodeInMarathi == "" || pincode == "") {
      message.innerHTML = "Please provide Pincode";
    } else {
      showHideLoader(true);

      memberObject.id = isCreate ? 0 : id;
      memberObject.applicationNumber = applicationNumber;
      memberObject.dateOfJoiningId = dateOfJoining;
      memberObject.statusId = selectedStatus;
      memberObject.titleId = title;
      memberObject.nameInMarathi = nameInMarathi;
      memberObject.name = name;
      memberObject.dateOfBirthId = dateOfBirth;
      memberObject.bloodGroupId = bloodGroup;
      memberObject.genderId = gender;
      memberObject.qualificationId = qualification;
      memberObject.occupationId = occupation;
      memberObject.mobile = mobile;
      memberObject.telephone = telephone;
      memberObject.email = mail;
      memberObject.isMailSubscriped = isMailSubscriped;
      memberObject.isMessageSubscriped = isMessageSubscriped;
      memberObject.addressInMarathi_1 = addressInMarathi_1;
      memberObject.address_1 = address_1;
      memberObject.addressInMarathi_2 = addressInMarathi_2;
      memberObject.address_2 = address_2;
      memberObject.addressInMarathi_3 = addressInMarathi_3;
      memberObject.address_3 = address_3;
      memberObject.customAreaInMarathi = customerAreaInMarathi;
      memberObject.customArea = customerArea;
      memberObject.stateId = state;
      memberObject.districtId = district;
      memberObject.talukaId = taluka;
      memberObject.areaId = area;
      memberObject.pincodeInMarathi = pincodeInMarathi;
      memberObject.pincode = pincode;
      memberObject.nativeAddressInMarathi_1 = nativeAddressInMarathi_1;
      memberObject.nativeAddress_1 = nativeAddress_1;
      memberObject.nativeAddressInMarathi_2 = nativeAddressInMarathi_2;
      memberObject.nativeAddress_2 = nativeAddress_2;
      memberObject.nativeAddressInMarathi_3 = nativeAddressInMarathi_3;
      memberObject.nativeAddress_3 = nativeAddress_3;
      memberObject.nativeCustomAreaInMarathi = nativeCustomerAreaInMarathi;
      memberObject.nativeCustomArea = nativeCustomerArea;
      memberObject.nativeStateId = nativeState;
      memberObject.nativeDistrictId = nativeDistrict;
      memberObject.nativeTalukaId = nativeTaluka;
      memberObject.nativeAreaId = nativeArea;
      memberObject.nativePincodeInMarathi = nativePincodeInMarathi;
      memberObject.nativePincode = nativePincode;
      memberObject.userName = user.userName;

      save(memberObject).then((res) => {
        if (res.status == 200 && res.data) {
          message.classList.replace("alert", "success");
          message.innerHTML = `Member ${
            isCreate ? "created" : "updated"
          } successfully!!!`;
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
        showHideLoader();
      });
    }
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            {isRead || isEdit ? (
              <td align="left">
                <span
                  onClick={() => setToDefault()}
                  style={{ textDecoration: "underline" }}
                >
                  New Member
                </span>
              </td>
            ) : (
              <td></td>
            )}
            <td colSpan={2}></td>
            <td align="right">
              <Link to="/admin/searchmember">
                <span>Search Member</span>
              </Link>
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Memeber Registration
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Member Id</span>
            </td>
            <td>
              <input
                type="text"
                disabled
                value={id}
                style={{ width: "294px" }}
              />
            </td>
            <td align="right">
              <span className="required">Application Number</span>
            </td>
            <td>
              <input
                type="text"
                value={applicationNumber}
                onChange={(e) => setApplicationNumber(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Date of Joining</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfJoining}
                onChange={(e) => setDateOfJoining(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
            <td align="right">
              <span className="required">Status</span>
            </td>
            <td>
              {status && (
                <select
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  value={selectedStatus}
                  disabled={isCreate || isRead}
                  style={{ width: "314px" }}
                >
                  {status.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Personal Details
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Title</span>
            </td>
            <td colSpan={3}>
              {titles && (
                <select
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="">Select</option>
                  {titles.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Name</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nameInMarathi}
                onChangeText={(text) => {
                  setNameInMarathi(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={name}
                onChange={(e) => setName(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Date of Birth</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
            <td align="right">
              <span>Blood Group</span>
            </td>
            <td>
              {bloodGroups && (
                <select
                  onChange={(e) => setBloodGroup(e.target.value)}
                  value={bloodGroup}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {bloodGroups.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Gender</span>
            </td>
            <td colSpan={3}>
              {genders &&
                genders.map((x, i) => (
                  <label
                    key={i}
                    htmlFor={x.name}
                    style={{ padding: "0px 25px" }}
                  >
                    <input
                      type="radio"
                      value={x.id}
                      name={x.name}
                      checked={gender == x.id}
                      onChange={(e) => setGender(e.target.value)}
                      disabled={isRead}
                    />
                    {x.name}
                  </label>
                ))}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Qualification</span>
            </td>
            <td>
              {qualifications && (
                <select
                  onChange={(e) => setQualification(e.target.value)}
                  value={qualification}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {qualifications.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>Occupation</span>
            </td>
            <td>
              {occupations && (
                <select
                  onChange={(e) => setOccupation(e.target.value)}
                  value={occupation}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {occupations.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Contact Details
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Mobile Number</span>
            </td>
            <td>
              <input
                type="number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
            <td align="right">
              <span>Telephone</span>
            </td>
            <td>
              <input
                type="number"
                value={telephone}
                onChange={(e) => setTelephone(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Email</span>
            </td>
            <td>
              <input
                type="email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                disabled={isRead}
                style={{ width: "294px" }}
              />
            </td>
            <td align="right">
              <span>Subscription</span>
            </td>
            <td>
              {subscriptions &&
                subscriptions.map((x, i) => {
                  const [isChecked] = subscriptionMap[x.id];
                  return (
                    <label
                      key={i}
                      htmlFor={x.name}
                      style={{ padding: "0px 30px" }}
                    >
                      <input
                        type="checkbox"
                        name={x.name}
                        checked={isChecked}
                        onChange={() => {
                          const [, setChecked] = subscriptionMap[x.id];
                          setChecked((prev) => !prev);
                        }}
                        disabled={isRead}
                      />
                      {x.name}
                    </label>
                  );
                })}
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Address Details
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Address 1</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={addressInMarathi_1}
                onChangeText={(text) => {
                  setAddressInMarathi_1(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={address_1}
                onChange={(e) => setAddress_1(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Address 2</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={addressInMarathi_2}
                onChangeText={(text) => {
                  setAddressInMarathi_2(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={address_2}
                onChange={(e) => setAddress_2(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Address 3</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={addressInMarathi_3}
                onChangeText={(text) => {
                  setAddressInMarathi_3(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={address_3}
                onChange={(e) => setAddress_3(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Area</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={customerAreaInMarathi}
                onChangeText={(text) => {
                  setCustomAreaInMarathi(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={customerArea}
                onChange={(e) => setCustomArea(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">State</span>
            </td>
            <td>
              {states && (
                <select
                  onChange={(e) => {
                    setState(e.target.value);
                    setDistricts(
                      [...originalDistricts].filter(
                        (x) => x.stateId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={state}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {states.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span className="required">District</span>
            </td>
            <td>
              {districts && districts.length > 0 && state != 0 ? (
                <select
                  onChange={(e) => {
                    setDistrict(e.target.value);
                    setTalukas(
                      [...originalTalukas].filter(
                        (x) => x.districtId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={district}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {districts.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid State</option>
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Taluka</span>
            </td>
            <td>
              {talukas && talukas.length > 0 && district != 0 ? (
                <select
                  onChange={(e) => {
                    setTaluka(e.target.value);
                    setAreas(
                      [...originalAreas].filter(
                        (x) => x.talukaId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={taluka}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {talukas.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid District</option>
                </select>
              )}
            </td>
            <td align="right">
              <span className="required">Area</span>
            </td>
            <td>
              {areas && areas.length > 0 && taluka != 0 ? (
                <select
                  onChange={(e) => {
                    setArea(e.target.value);
                  }}
                  value={area}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {areas.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid Taluka</option>
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Pincode</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={pincodeInMarathi}
                onChangeText={(text) => {
                  setPincodeInMarathi(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Native Address Details
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Address 1</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nativeAddressInMarathi_1}
                onChangeText={(text) => {
                  setNativeAddressInMarathi_1(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={nativeAddress_1}
                onChange={(e) => setNativeAddress_1(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Address 2</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nativeAddressInMarathi_2}
                onChangeText={(text) => {
                  setNativeAddressInMarathi_2(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={nativeAddress_2}
                onChange={(e) => setNativeAddress_2(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Address 3</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nativeAddressInMarathi_3}
                onChangeText={(text) => {
                  setNativeAddressInMarathi_3(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={nativeAddress_3}
                onChange={(e) => setNativeAddress_3(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Area</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nativeCustomerAreaInMarathi}
                onChangeText={(text) => {
                  setNativeCustomAreaInMarathi(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={nativeCustomerArea}
                onChange={(e) => setNativeCustomArea(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>State</span>
            </td>
            <td>
              {states && (
                <select
                  onChange={(e) => {
                    setNativeState(e.target.value);
                    setNativeDistricts(
                      [...originalDistricts].filter(
                        (x) => x.stateId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={nativeState}
                  disabled={isRead}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {states.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>District</span>
            </td>
            <td>
              {nativeDistricts &&
              nativeDistricts.length > 0 &&
              nativeState != 0 ? (
                <select
                  onChange={(e) => {
                    setNativeDistrict(e.target.value);
                    setNativeTalukas(
                      [...originalTalukas].filter(
                        (x) => x.districtId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={nativeDistrict}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {nativeDistricts.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid State</option>
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Taluka</span>
            </td>
            <td>
              {nativeTalukas &&
              nativeTalukas.length > 0 &&
              nativeDistrict != 0 ? (
                <select
                  onChange={(e) => {
                    setNativeTaluka(e.target.value);
                    setNativeAreas(
                      [...originalAreas].filter(
                        (x) => x.talukaId == parseInt(e.target.value)
                      )
                    );
                  }}
                  value={nativeTaluka}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {nativeTalukas.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid District</option>
                </select>
              )}
            </td>
            <td align="right">
              <span>Area</span>
            </td>
            <td>
              {nativeAreas && nativeAreas.length > 0 && nativeTaluka != 0 ? (
                <select
                  onChange={(e) => {
                    setNativeArea(e.target.value);
                  }}
                  value={nativeArea}
                  style={{ width: "314px" }}
                >
                  <option value="0">Select</option>
                  {nativeAreas.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              ) : (
                <select disabled={isRead} style={{ width: "314px" }}>
                  <option value="0">Please select valid Taluka</option>
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Pincode</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="38" disabled={isRead} />
                )}
                value={nativePincodeInMarathi}
                onChangeText={(text) => {
                  setNativePincodeInMarathi(text);
                }}
                lang="mr"
              />
            </td>
            <td></td>
            <td>
              <textarea
                value={nativePincode}
                onChange={(e) => setNativePincode(e.target.value)}
                rows="1"
                cols="38"
                disabled={isRead}
              ></textarea>
            </td>
          </tr>
          {!isRead && (
            <>
              <tr>
                <td colSpan={2}></td>
                <td
                  colSpan={2}
                  style={{ textAlign: "right", paddingRight: "23px" }}
                >
                  {!isEdit && (
                    <input
                      className="btn"
                      type="submit"
                      value="Cancel"
                      id="btnCancel"
                      onClick={handleCancel}
                    />
                  )}
                  &nbsp;&nbsp;
                  <input
                    className="btn"
                    type="submit"
                    value="Submit"
                    id="btnSubmit"
                    onClick={handleSubmit}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  <div
                    id="message"
                    className="alert"
                    style={{ textAlign: "center" }}
                  ></div>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </>
  );

  return contents;
}

export default SaveMember;
